import { render, staticRenderFns } from "./ProspectorScreen.vue?vue&type=template&id=82ef9022"
import script from "./ProspectorScreen.vue?vue&type=script&lang=js"
export * from "./ProspectorScreen.vue?vue&type=script&lang=js"
import style0 from "./ProspectorScreen.vue?vue&type=style&index=0&id=82ef9022&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports